export const CURRENCY = 'CURRENCY';
export const DATE = 'DATE';
export const KILLSHEET_NUMBER = 'KILLSHEET NUMBER';
export const INVOICE_REFERENCE = 'INVOICE REFERENCE';
export const NUMBER = 'NUMBER';
export const NUMBER_WITH_COMMAS = 'NUMBER WITH COMMAS';
export const STRING = 'STRING';
export const WEIGHT = 'WEIGHT';